<template>
  <div class="leaderboard">

    <h5 class="leaderboard__title">
      Team Leaderboard
    </h5>

    <div v-if="!isLeaderBoardDisabled">
      <v-data-table
        :items="teams"
        :search="search"
        hide-actions
        class="elevation-1"
        no-data-text="Loading Team LeaderBoard..."
      >
        <template slot="headers" slot-scope="headers">&nbsp;</template>
        <template slot="items" slot-scope="props">
          <td class=" text-xs-right cell--team-profile-picture">
            <v-avatar size="60px" slot="activator" v-if="props.item.imageUrl" class="mr-3">
              <img :src="props.item.imageUrl"/>
            </v-avatar>
          </td>
          <td class="text-xs-center cell--name h1">
            <h6>{{ props.item.name }}</h6>
          </td>
          <td class="text-xs-left cell--score h4">
            <h6>{{ props.item.score }}</h6>
          </td>
          <td class="cell--team-medal-icon">
            <img
              v-if="props.item.name === first && props.item.score > 0"
              src="/static/img/leaderboard/trophy.svg"
            />
          </td>
        </template>
      </v-data-table>
    </div>
    <div v-else>
      <p class="text-no-leaderboard">
        The leaderBoard is not available for now
      </p>

    </div>

  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'

  const actions = mapActions([
    'getTeamLeaderboard',
  ])

  const getters = mapGetters(['game'])

  export default {
    name: 'teamleaderboard',
    data () {
      return {
        teams: [],
        showLoading: true,
        search: '',
        first: String,
        second: String,
        third: String,
        isLeaderBoardDisabled: false,
      }
    },
    created () {
      this.getTeamLeaderboard()
        .then(response => {
          if (response.data.isLeaderDisabled) {
            this.isLeaderBoardDisabled = true
          } else {
            this.isLeaderBoardDisabled = false
            this.teams = response.data.teams.slice(0, 15)
            if (response.data[0]) {
              this.first = response.data[0].name
            }
          }
        })
        .catch(err => {

          console.error(err)
        })
        .finally(() => {
          this.showLoading = false
        })
    },
    computed: {
      ...getters,
    },
    methods: {
      ...actions,
      customFilter (items, search, filter) {
        search = search.toString().toLowerCase()
        return items.filter(i => (
          filter(i.name, search)
        ))
      }
    },
  }
</script>

<style lang="scss" type="text/scss" scoped>

  .leaderboard {
    background-color: #fafafa;
  }

  .leaderboard__title {
    margin-top: 20px;
  }

  .table {
    max-width: 450px !important;
    margin-left: auto;
    margin-right: auto;
    font-family: 'Calibri';
  }

  .display-1 {

  }

  .text-no-leaderboard {
    margin-top: 40px;
    font-style: italic;
    font-size: large;
    color: rgba(107,105,110,0.9);
  }


</style>



// WEBPACK FOOTER //
// src/components/TeamLeaderboard.vue